'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const CommentContainer = styled__default["default"].div.withConfig({
  componentId: "sc-zogw7z-0"
})(["border:1px solid #999999;padding:0.3rem;"]);
const ClaimSummaryComment = _ref => {
  let {
    comment
  } = _ref;
  const {
    claimsSummaryComment
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(CommentContainer, null, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    containerCustomStyle: {
      margin: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, claimsSummaryComment, ": "), comment));
};
var ClaimSummaryComment$1 = nthHookTranslations.withTranslationsProvider(ClaimSummaryComment, {
  translationKeys: ['claimsSummaryComment']
});

exports["default"] = ClaimSummaryComment$1;
